// src/pages/Archiver/ArchiverLayout.js
import React, { useState, useEffect, useContext } from 'react';
import { Outlet } from 'react-router-dom';
import axios from 'axios';
import PageLayout from '../PageLayout';
import SidebarAccordion from '../../components/SidebarAccordion';
import { SidebarContext } from '../../context/SidebarContext';
import { isSeriesActive, isSeriesExpired } from '../../utils/helpers';
import './ArchiverLayout.css';
import { FaCalendarAlt, FaClipboardList, FaPlusCircle, FaChartLine, FaFileAlt } from 'react-icons/fa';

function ArchiverLayout() {
  const { sidebarOpen } = useContext(SidebarContext);
  const [seriesList, setSeriesList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    setLoading(true);
    axios
      .get('/api/exam-series')
      .then((res) => {
        setSeriesList(res.data);
        setLoading(false);
      })
      .catch(() => {
        setError('Error fetching active series.');
        setLoading(false);
      });
  }, []);

  const emptySeriesChildren = [{ title: loading ? 'Loading...' : 'Nothing to show here', path: '#', icon: <FaCalendarAlt /> }];
  // Filter first, then check the *filtered* length - checking the raw
  // seriesList's length instead (as this used to) means a non-empty list
  // where every series happens to be active/expired the "wrong" way for a
  // given section renders as an empty children array rather than the
  // "Nothing to show here" fallback, which the tree's stricter
  // children.length > 0 check then renders as a dead leaf with no
  // expand arrow at all instead of a visibly-empty branch.
  const activeSeries = seriesList.filter(series => isSeriesActive(series));
  const expiredSeries = seriesList.filter(series => isSeriesExpired(series));

  const menuItems = [
    {
      title: 'Active Series',
      icon: <FaCalendarAlt />,
      children: activeSeries.length > 0
        ? activeSeries.map((series) => ({
            title: series.name,
            path: `/archiver/active-series/${series.id}`,
            icon: <FaCalendarAlt />
          }))
        : emptySeriesChildren,
    },
    {
      title: 'Allocate',
      icon: <FaClipboardList />,
      children: [
        { title: 'Assign Work', path: '/archiver/allocate/assign', icon: <FaPlusCircle /> },
        { title: 'Progress', path: '/archiver/allocate/progress', icon: <FaChartLine /> }
      ],
    },
    {
      title: 'Report',
      icon: <FaFileAlt />,
      children: [
        { title: 'Work Uploaded Report', path: '/archiver/reports/work-uploaded', icon: <FaFileAlt /> },
        { title: 'Students Work Download', path: '/archiver/reports/students-work', icon: <FaFileAlt /> },
        { title: 'Candidate Work Status', path: '/archiver/reports/candidate-work-status', icon: <FaFileAlt /> },
      ],
    },
    {
      title: 'Exam Series',
      icon: <FaCalendarAlt />,
      children: expiredSeries.length > 0
        ? expiredSeries.map((series) => ({
            title: series.name,
            path: `/archiver/exam-series/${series.id}`,
            icon: <FaCalendarAlt />
          }))
        : emptySeriesChildren,
    },
  ];

  return (
    <div className="archiver-layout">
      <div className={`archiver-layout-body ${sidebarOpen ? 'sidebar-open' : ''}`}>
        <SidebarAccordion menuItems={menuItems} treeStyle />
        <div className="main-content">
          <PageLayout>
            <Outlet />
          </PageLayout>
        </div>
      </div>
    </div>
  );
}

export default ArchiverLayout;
